import { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { slice } from 'lodash';

// Components
import { StyledWhiteBox } from 'src/features/PortDetail/config';
import { renderTextOrDefault } from 'src/utils/helpers/stringHelpers';
import { LIMIT_GET_LIST } from 'src/utils/constants/config';
import Table from 'src/components/Table';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import { formatNumberWithChar } from 'src/utils/helpers/number';

// Utilities
import { IPortOperator } from 'src/utils/typings/response';

interface IProps {
  listAllOperators: Array<IPortOperator>;
}

const OperatorsTable = ({ listAllOperators }: IProps) => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(LIMIT_GET_LIST);
  const [listOperators, setListOperators] = useState<Array<IPortOperator>>([]);

  useEffect(() => {
    const initialList = slice(getArrayDefault(listAllOperators), page * pageSize, (page + 1) * pageSize);
    setListOperators(initialList);
  }, [listAllOperators, page]);

  const configColumn: ConfigCell<IPortOperator>[] = [
    {
      id: 'operators',
      disablePadding: true,
      disableSort: true,
      label: 'Operators',
      cell: (row: IPortOperator) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {renderTextOrDefault(row?.operator)}
          </Typography>
        );
      },
    },
    {
      id: 'exports',
      disablePadding: true,
      disableSort: true,
      label: 'Exports',
      cell: (row: IPortOperator) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {formatNumberWithChar(row?.exports)}
          </Typography>
        );
      },
    },
    {
      id: 'capacity',
      disablePadding: true,
      disableSort: true,
      label: 'Capacity',
      cell: (row: IPortOperator) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {formatNumberWithChar(row?.capacity)}
          </Typography>
        );
      },
    },
    {
      id: 'portcalls',
      disablePadding: true,
      disableSort: true,
      label: 'Portcalls',
      cell: (row: IPortOperator) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {formatNumberWithChar(row?.portcalls)}
          </Typography>
        );
      },
    },
  ];

  return (
    <StyledWhiteBox display="flex" flexDirection="column" gap={2}>
      <Typography variant="h5" align="left">
        Operators
      </Typography>
      <Table
        data={listOperators}
        configColumn={configColumn}
        dataKey="operator"
        onChangePage={(e) => setPage(e)}
        onChangePageSize={(e) => setPageSize(e)}
        page={page}
        pageSize={pageSize}
        maxRow={10}
        totalRecords={getArrayDefault(listAllOperators).length}
      />
    </StyledWhiteBox>
  );
};

export default OperatorsTable;
